import { AppConfigModel } from "../abstract/app-config.model";

export class LegalStatus extends AppConfigModel {

    static override CLASS_NAME: string = 'LegalStatus';
}
